import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react18-router';

import resetOnLogout from './decorators/resetOnLogout';
import resetOnLogin from './decorators/resetOnLogin';
import contact from './contact';
import search from './search';
import user from './user';
import auth from './auth';
import nextAction from './nextAction';
import targetCompany from './company';
import companyTradeGroups from './companyTradeGroups';
import dashboards from './dashboards';
import dialPadPusher from './dialPadPusher';
import directorDashboard from './directorDashboard';
import dialPadCall from './dialPadCall';
import popup from './popup';
import browse from './browse';
import project from './project';
import eproject from './eproject';
import approval from './approval';
import autoComplete from './autoComplete';
import applicationErrors from './applicationErrors';
import buyerPopup from './buyerPopup';
import backlog from './backlog';
import mailingHistory from './mailingHistory';
import mailingLogs from './mailingLogs';
import mailingCreate from './mailingCreate';
import mailingInfo from './mailingInfo';
import countries from './countries';
import tags from './tags';
import statuses from './statuses';
import eventActivities from './eventActivities';
import industryTags from './industryTags';
import businessModels from './businessModels';
import meetings from './meetings';
import oneOff from './oneOff';
import verifyEmail from './verifyEmail';
import findEmail from './findEmail';
import windward from './windward';
import tradeShow from './tradeShow';
import statistics from './statistics';
import leadsReport from './leadsReport';
import windwardReportsPopup from './popup/windwardReportsPopup';
import emailTemplates from './emailTemplates';
import agreementCategories from './agreementCategories';
import emailTemplatesSendGrid from './emailTemplatesSendGrid';
import retainerHealthReport from './retainerHealthReport';

const createRootReducer = history =>
  resetOnLogout(
    combineReducers({
      router: connectRouter(history),
      contact,
      search,
      user,
      auth,
      nextAction,
      dashboards,
      dialPadPusher,
      directorDashboard,
      dialPadCall,
      popup: resetOnLogin(popup),
      browse,
      targetCompany,
      tradeShow,
      statistics,
      companyTradeGroups,
      project,
      eproject,
      approval,
      autoComplete,
      applicationErrors: resetOnLogin(applicationErrors),
      buyerPopup,
      mailingHistory,
      mailingLogs,
      mailingCreate,
      mailingInfo,
      backlog,
      countries,
      tags,
      eventActivities,
      statuses,
      industryTags,
      businessModels,
      meetings,
      oneOff,
      verifyEmail,
      findEmail,
      windward,
      leadsReport,
      windwardReportsPopup,
      emailTemplates,
      agreementCategories,
      emailTemplatesSendGrid,
      retainerHealthReport,
    }),
  );

export default createRootReducer;
